import { get, map, pick, split, toNumber } from 'lodash'

import { isBooleanTrue } from '../../../core/utils'

import { showErrorNotification } from '../../../common/helpers'

import { INGREDIENT_SPECIAL_CASE_TYPES } from '../../constants'

const transformToSaveIngredientSpecialCaseArgs = data => {
  try {
    return {
      ...pick(data, ['name', 'type', 'description']),
      caseDefinition: JSON.stringify({
        ...data.caseDefinition,
        ...(data.type === INGREDIENT_SPECIAL_CASE_TYPES.PARSING_RULE
          ? {
              shift_indexes: map(
                get(data.caseDefinition, 'shift_indexes'),
                shiftIndex => toNumber(shiftIndex),
              ),
              exclude_pair: isBooleanTrue(
                get(data.caseDefinition, 'exclude_pair'),
              ),
            }
          : {}),
        ...(data.type === INGREDIENT_SPECIAL_CASE_TYPES.IGNORED_COMBINATION
          ? { tokens: split(data.caseDefinition.tokens, '\n') }
          : {}),
      }),
    }
  } catch (error) {
    return showErrorNotification({
      title: 'Conversion error',
      description: 'exclude_pair not true or false',
    })
  }
}

export default transformToSaveIngredientSpecialCaseArgs
